module.exports = __webpack_public_path__ + "static/media/piper-traffic-light-green.2920d6e4.svg";